import { IAddon, createAddon, registerOperationHandler } from '@ms/items-view/lib/private/addons/registerOperationHandler';
import { IItemCacheDispatch } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { getSPItemSetAddon } from '../handlers/operations/spItemSet/getItemsOperationHandler';
import { getSPFolderItemSetAddon } from '../handlers/operations/spFolderItemSet/getItemsOperationHandler';
import { getSPItemsAddon } from '../handlers/operations/spItem/getItemsOperationHandler';
import { getSPItemEngagementAddon } from '../handlers/controls/spItem/itemEngagementControlHandler';
import { SPCoreAddon } from './SpCoreAddon';
import {
  spItemPageKeyFacet,
  spItemGroupKeyFacet,
  spItemNextGroupPageKeyFacet,
  spItemTokenGroupPageKeyFacet,
  spItemKeyFacet,
  spFolderItemSetKeyFacet
} from './Keys';
import { getItemsOperation, supportFacets } from '@ms/items-view/lib/private/operations/getItems';
import { spItemPageGetItemsOperationHandler } from '../handlers/operations/spItemPage/getItemsOperationHandler';
import { spItemGroupGetItemsOperationHandler } from './getSPItemGroup';
import { childItemsFacet } from '@ms/items-view/lib/private/facets/SetFacets';
import { isGroupFacet } from '@ms/items-view/lib/private/facets/GroupFacets';
import { spItemTokenGroupPageGetItemsOperationHandler } from '../handlers/operations/spItemTokenGroupPage/getItemsOperationHandler';
import { spItemNextGroupPageGetItemsOperationHandler } from '../handlers/operations/spItemNextGroupPage/getItemsOperationHandler';
import { registerControlHandler } from '@ms/items-view/lib/private/addons/registerControlHandler';
import { openActionControlHandler } from '../controls/openActionControl';
import { openActionControl } from '@ms/items-view/lib/private/controls/openActionControl';
import { itemsBreadcrumbBetaControlHandler } from '../handlers/controls/itemsBreadcrumbBetaControl';
import { itemsBreadcrumbBetaControl } from '@ms/items-view/lib/private/controls/itemsBreadcrumbBetaControl';

export const sharePointReadOnlyAddon: IAddon = createAddon(() => {
  return async (dispatch: IItemCacheDispatch) => {
    dispatch(supportFacets({
      keyFacet: spItemGroupKeyFacet,
      facets: [
        childItemsFacet
      ]
    }));

    dispatch(supportFacets({
      keyFacet: spItemNextGroupPageKeyFacet,
      facets: [
        isGroupFacet,
        childItemsFacet
      ]
    }));

    dispatch(supportFacets({
      keyFacet: spItemTokenGroupPageKeyFacet,
      facets: [
        isGroupFacet,
        childItemsFacet
      ]
    }));

    dispatch(SPCoreAddon);
    dispatch(getSPItemSetAddon);
    dispatch(getSPFolderItemSetAddon);
    dispatch(getSPItemsAddon);
    dispatch(getSPItemEngagementAddon);

    dispatch(registerOperationHandler(spItemGroupKeyFacet, getItemsOperation)(
      spItemGroupGetItemsOperationHandler
    ));

    dispatch(registerOperationHandler(spItemPageKeyFacet, getItemsOperation)(
      spItemPageGetItemsOperationHandler
    ));

    dispatch(registerOperationHandler(spItemTokenGroupPageKeyFacet, getItemsOperation)(
      spItemTokenGroupPageGetItemsOperationHandler
    ));

    dispatch(registerOperationHandler(spItemNextGroupPageKeyFacet, getItemsOperation)(
      spItemNextGroupPageGetItemsOperationHandler
    ));

    dispatch(registerControlHandler(spItemKeyFacet, openActionControl)(
      openActionControlHandler
    ));

    dispatch(registerControlHandler(spFolderItemSetKeyFacet, openActionControl)(
      openActionControlHandler
    ));

    dispatch(registerControlHandler(spItemKeyFacet, itemsBreadcrumbBetaControl)(
      itemsBreadcrumbBetaControlHandler
    ));
  };
});